import React from 'react';
import ReactDOM from 'react-dom/client';
import './Scss/master.scss';
import App from './App';
import NavigationBar from './Components/NavigationBar';
import Footer from './Components/Footer';
import SkipButton from './Components/SkipButton';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SkipButton/>
    <NavigationBar/>
    <App />
    <Footer/>
  </React.StrictMode>
);
